import React from 'react';
import { XCircle } from 'lucide-react';

function ModalRaport({ children, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 dark:bg-black/60 backdrop-blur-sm px-4">
      <div className="relative card-premium w-full max-w-4xl overflow-y-auto max-h-[85vh] animate-fadeIn p-6">
        
        {/* Butoni për mbyllje */}
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-400 dark:text-gray-500 hover:text-red-600 dark:hover:text-red-400 transition-colors"
          aria-label="Mbylle"
        >
          <XCircle size={26} />
        </button>

        {children}
      </div>
    </div>
  );
}

export default ModalRaport;
